import styled, { css } from 'styled-components/macro'
import { ifProp, prop } from 'styled-tools'
import { rem, media, rgba } from '../../utils/styles'

const SectionWrapper = styled.div`
  padding: ${rem(20)} ${rem(20)} ${rem(10)} 0;
  /* border-bottom: ${rem(1)} solid ${rgba('base', 0.3)}; */
  ${ifProp('align', css`
    text-align: ${prop('align')};
  `)}

  &:last-child {
    padding-bottom: ${rem(50)};
  }

  &:hover {
    border-bottom-color: ${rgba('base', 1)};
  }

  ${media('tablet')`
    padding-left: ${rem(30)};
  `}

  ${media('desktop')`
    padding-left: ${rem(50)};
  `}
`

export default SectionWrapper
